import React from "react";

import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";
import { FormLabel, GridLegacy } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import Divider from "@mui/material/Divider";
import { useWatch } from "react-hook-form";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";

//Variabele importeren

function SubsPricePlanGeneral({ ...props }) {
  const { classes } = props;

  // const subs_price_plan_id = useWatch({ name: "subs_price_plan_id" });
  // const subs_price_plan_description = useWatch({ name: "subs_price_plan.description" });
  const subs_debtor_id = useWatch({ name: "subs_debtor_id" });
  const isCommissionPricePlan = subs_debtor_id > 0;
  const suffix = isCommissionPricePlan ? "_commission" : "";

  let infoFields = [];
  if (!isCommissionPricePlan) {
    infoFields = [
      "name",
      "description",
      { type: "price", key: "price_monthly" },
      { type: "price", key: "price_digital_menu_card_monthly" },
      { type: "price", key: "price_core_qr_monthly" },
      { type: "price", key: "price_sales_area_monthly" },

      { type: "price", key: "price_core_tablet_monthly" },
      { type: "price", key: "price_core_webshop_monthly" },
      { type: "price", key: "price_core_kiosk_monthly" },
      { type: "price", key: "price_extra_kiosk_monthly" },
      // { type: "price", key: "price_psp_integration_monthly" },
      { type: "price", key: "price_pos_integration_monthly" },
      { type: "price", key: "price_standalone_monthly" },
      { type: "price", key: "price_server_basic_monthly" },
      { type: "price", key: "price_gateway_monthly" },
      { type: "price", key: "price_per_sms_local_country" },
      // { type: "price", key: "price_per_sms_foreign_country" },
      // { type: "price", key: "price_per_order" },
      // { type: "price", key: "price_whitelabel_monthly" },
      // { type: "price", key: "price_startup_fee" },
      { type: "percentage", key: "monthly_surcharge" },
      { type: "percentage", key: "monthly_discount" },
    ];
  } else {
    infoFields = [
      "name",
      "description",
      { type: "price", key: "price_monthly" },
      { type: "percentage", key: "price_monthly" + suffix },
      { type: "price", key: "price_digital_menu_card_monthly" },
      { type: "percentage", key: "price_digital_menu_card_monthly" + suffix },
      { type: "price", key: "price_core_qr_monthly" },
      { type: "percentage", key: "price_core_qr_monthly" + suffix },
      { type: "price", key: "price_sales_area_monthly" },
      { type: "percentage", key: "price_sales_area_monthly" + suffix },
      { type: "price", key: "price_core_tablet_monthly" },
      { type: "percentage", key: "price_core_tablet_monthly" + suffix },
      { type: "price", key: "price_core_webshop_monthly" },
      { type: "percentage", key: "price_core_webshop_monthly" + suffix },
      { type: "price", key: "price_core_kiosk_monthly" },
      { type: "percentage", key: "price_core_kiosk_monthly" + suffix },
      { type: "price", key: "price_extra_kiosk_monthly" },
      { type: "percentage", key: "price_extra_kiosk_monthly" + suffix },
      // { type: "price", key: "price_psp_integration_monthly" },
      // { type: "percentage", key: "price_psp_integration_monthly" + suffix },
      { type: "price", key: "price_pos_integration_monthly" },
      { type: "percentage", key: "price_pos_integration_monthly" + suffix },
      { type: "price", key: "price_standalone_monthly" },
      { type: "percentage", key: "price_standalone_monthly" + suffix },
      { type: "price", key: "price_server_basic_monthly" },
      { type: "percentage", key: "price_server_basic_monthly" + suffix },
      { type: "price", key: "price_gateway_monthly" },
      { type: "percentage", key: "price_gateway_monthly" + suffix },
      // { type: "price", key: "price_per_sms_local_country" },
      // { type: "percentage", key: "price_per_sms_local_country" + suffix },
      // { type: "price", key: "price_per_sms_foreign_country" },
      // { type: "percentage", key: "price_per_sms_foreign_country" + suffix },
      // { type: "price", key: "price_per_order" },
      // { type: "percentage", key: "price_per_order" + suffix },
      // { type: "price", key: "price_whitelabel_monthly" },
      // { type: "percentage", key: "price_whitelabel_monthly" + suffix },
      // { type: "price", key: "price_startup_fee" },
      // { type: "percentage", key: "price_startup_fee" + suffix },
    ];
  }

  const paymentProviders = [
    {
      name: "CM",
      paymentMethods: [
        { name: "IDEAL" },
        { name: "AMEX" },
        { name: "BELFIUS_PAY_BUTTON" },
        { name: "EBANKING" },
        { name: "MAESTRO" },
        { name: "MASTERCARD" },
        { name: "MISTERCASH" },
        { name: "PAYPAL_EXPRESS_CHECKOUT" },
        { name: "VISA" },
      ],
    },
    { name: "ADYEN", paymentMethods: [{ name: "IDEAL" }, { name: "PIN" }] },
    {
      name: "MOLLIE",
      paymentMethods: [
        { name: "IDEAL" },
        { name: "BANCONTACT" },
        { name: "BELFIUS" },
        { name: "CREDITCARD" },
        { name: "GIROPAY" },
        { name: "KBC" },
        { name: "PAYPAL" },
        { name: "SOFORT" },
      ],
    },
    {
      name: "PAGADIRECT",
      paymentMethods: [{ name: "" }],
    },
    {
      name: "PAYMENTSENSE",
      paymentMethods: [{ name: "" }],
    },
    {
      name: "PAYNL",
      paymentMethods: [
        { name: "iDEAL" },
        { name: "ALIPAY" },
        { name: "AMEX" },
        { name: "APPLE PAY" },
        { name: "Bancontact" },
        { name: "CARTE BLEUE" },
        { name: "GIROPAY" },
        { name: "MAESTRO" },
        { name: "PAYCONIQ" },
        { name: "PAYPAL" },
        { name: "PIN" },
        { name: "POSTEPAY" },
        { name: "PRZELEWY24" },
        { name: "SOFORT E-COMMERCE" },
        { name: "VISA MASTERCARD" },
        { name: "WECHAT PAY" },
      ],
    },
    {
      name: "SAFERPAY",
      paymentMethods: [
        { name: "IDEAL" },
        { name: "MAESTRO" },
        { name: "MASTERCARD" },
        { name: "PAYPAL" },
        { name: "TWINT" },
        { name: "VISA" },
      ],
    },
    {
      name: "STRIPE",
      paymentMethods: [{ name: "IDEAL" }, { name: "CARD" }],
    },
  ];

  const formPayments = useWatch({ name: "payments" });
  let payments = formPayments ?? {};
  if (typeof payments === "string") {
    payments = {};
  }

  paymentProviders.forEach((paymentProvider) => {
    if (payments.paymentProviders == null) {
      payments.paymentProviders = {};
    }
    if (payments.paymentProviders[paymentProvider.name] == null) {
      payments.paymentProviders[paymentProvider.name] = {};
    }

    paymentProvider.paymentMethods.forEach((paymentMethod) => {
      if (payments.paymentProviders[paymentProvider.name][paymentMethod.name] == null) {
        payments.paymentProviders[paymentProvider.name][paymentMethod.name] = {};
      }
    });
  });

  const handlePaymentChange = (paymentProvider, paymentMethod, field, value) => {
    let newPayments = { ...payments };
    newPayments.paymentProviders[paymentProvider][paymentMethod][field] = value;
    props.parent.handleValue("payments", newPayments);
  };

  return (
    <>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tKey={"Price Plan information"} />
              </h3>
            </GridLegacy>

            <GridLegacy item sm={4} xs={12}>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper tKey={"Type"} />
              </FormLabel>
            </GridLegacy>

            <GridLegacy item sm={4} xs={12}>
              {isCommissionPricePlan ? (
                <TranslationWrapper tKey={"Commission Price Plan"} />
              ) : (
                <TranslationWrapper tKey={"Price Plan"} />
              )}
            </GridLegacy>

            {infoFields.map((field) => {
              if (field instanceof Object) {
                switch (field.type) {
                  case "price":
                    return (
                      <FormControlledInputTC
                        name={field.key}
                        tDefault={field.key}
                        tKey={"subsPricePlan." + field.key}
                        type={"currency"}
                      />
                    );
                  case "number":
                    return (
                      <FormControlledInputTC
                        name={field.key}
                        tDefault={field.key}
                        tKey={"subsPricePlan." + field.key}
                        type={"number"}
                      />
                    );
                  case "percentage":
                    return (
                      <FormControlledInputTC
                        fieldProps={({ value, onChange }) => ({
                          value: value * 100,
                          onHandleValue: (value) => {
                            value = value / 100.0;
                            onChange(
                              { target: { value: value ? String(value) : value } },
                              value ? String(value) : value
                            );
                          },
                          controlled: true,
                          type: "number",
                          suffix: " %",
                          nullable: undefined,
                        })}
                        name={field.key}
                        suffix={" %"}
                        tDefault={field.key}
                        tKey={"subsPricePlan." + field.key}
                        type={"number"}
                      />
                    );
                }
              }

              return <FormTextTC name={field} tDefault={field} tKey={"subsPricePlans." + field} />;
            })}
          </GridLegacy>
          <Divider />

          {/*{isCommissionPricePlan ? (*/}
          {/*  <GridContainer>*/}
          {/*    <GridItem xs={4}>*/}
          {/*      <TranslationWrapper tKey={"Belongs to price plan:"} />*/}
          {/*    </GridItem>*/}
          {/*    <GridItem xs={4}>*/}
          {/*      <Link to={`/manager/subspriceplans/${subs_price_plan_id}/edit?`}>{subs_price_plan_description}</Link>*/}
          {/*    </GridItem>*/}
          {/*  </GridContainer>*/}
          {/*) : (*/}
          {/*  <GridContainer>*/}
          {/*    <GridItem xs={4}>*/}
          {/*      <TranslationWrapper tKey={"Has the following commission price plans:"} />*/}
          {/*    </GridItem>*/}
          {/*    <GridItem xs={4} container style={{ flexDirection: "column" }}>*/}
          {/*      {props.parent.state.original.subs_price_plans?.map((subsPricePlan) => {*/}
          {/*        return (*/}
          {/*          <Link to={`/manager/subspriceplans/${subsPricePlan.id}/edit?`}>{subsPricePlan.description}</Link>*/}
          {/*        );*/}
          {/*      })}*/}
          {/*    </GridItem>*/}
          {/*  </GridContainer>*/}
          {/*)}*/}
        </CardBody>
      </Card>
      {/*<Card>*/}
      {/*  <CardBody>*/}
      {/*    <GridContainer>*/}
      {/*      <GridItem xs={12} sm={12}>*/}
      {/*        <h3>*/}
      {/*          <TranslationWrapper tKey={"Payments"} />*/}
      {/*        </h3>*/}
      {/*      </GridItem>*/}

      {/*      <input type="hidden" name="payments" value={JSON.stringify(props.parent.state.formdata.payments ?? {})} />*/}

      {/*      <Table>*/}
      {/*        <TableHead>*/}
      {/*          <TableRow style={{ fontWeight: 800, fontSize: "1.1rem" }}>*/}
      {/*            <TableCell>Payment Provider</TableCell>*/}
      {/*            <TableCell>Payment Method</TableCell>*/}
      {/*            <TableCell>Price</TableCell>*/}
      {/*            <TableCell>Percentage</TableCell>*/}
      {/*            <TableCell>Purchase price</TableCell>*/}
      {/*            <TableCell>Purchase percentage</TableCell>*/}
      {/*          </TableRow>*/}
      {/*        </TableHead>*/}
      {/*        <TableBody>*/}
      {/*          {paymentProviders.map((paymentProvider) => {*/}
      {/*            return paymentProvider.paymentMethods.map((paymentMethod) => {*/}
      {/*              return (*/}
      {/*                <TableRow>*/}
      {/*                  <TableCell>*/}
      {/*                    <Typography>{paymentProvider.name}</Typography>*/}
      {/*                  </TableCell>*/}
      {/*                  <TableCell>*/}
      {/*                    <Typography style={{ fontWeight: 800 }}>{paymentMethod.name}</Typography>*/}
      {/*                  </TableCell>*/}
      {/*                  <TableCell>*/}
      {/*                    <NumberInput*/}
      {/*                      type="valuta"*/}
      {/*                      currency={props.parent.state.original.valuta}*/}
      {/*                      value={*/}
      {/*                        props.parent.state.formdata.payments?.paymentProviders?.[paymentProvider.name]?.[*/}
      {/*                          paymentMethod.name*/}
      {/*                        ]?.price ?? 0*/}
      {/*                      }*/}
      {/*                      onChange={(e) => {*/}
      {/*                        handlePaymentChange(paymentProvider.name, paymentMethod.name, "price", e.value);*/}
      {/*                      }}*/}
      {/*                    />*/}
      {/*                  </TableCell>*/}
      {/*                  <TableCell>*/}
      {/*                    <CustomPercentageInput*/}
      {/*                      value={*/}
      {/*                        props.parent.state.formdata.payments?.paymentProviders?.[paymentProvider.name]?.[*/}
      {/*                          paymentMethod.name*/}
      {/*                        ]?.percentage ?? 0*/}
      {/*                      }*/}
      {/*                      onChange={(e) => {*/}
      {/*                        handlePaymentChange(*/}
      {/*                          paymentProvider.name,*/}
      {/*                          paymentMethod.name,*/}
      {/*                          "purchase_percentage",*/}
      {/*                          e.value*/}
      {/*                        );*/}
      {/*                      }}*/}
      {/*                    />*/}
      {/*                  </TableCell>*/}
      {/*                  <TableCell>*/}
      {/*                    <NumberInput*/}
      {/*                      type="valuta"*/}
      {/*                      currency={props.parent.state.original.valuta}*/}
      {/*                      value={*/}
      {/*                        props.parent.state.formdata.payments?.paymentProviders?.[paymentProvider.name]?.[*/}
      {/*                          paymentMethod.name*/}
      {/*                        ]?.purchase_price ?? 0*/}
      {/*                      }*/}
      {/*                      onChange={(e) => {*/}
      {/*                        handlePaymentChange(paymentProvider.name, paymentMethod.name, "purchase_price", e.value);*/}
      {/*                      }}*/}
      {/*                    />*/}
      {/*                  </TableCell>*/}
      {/*                  <TableCell>*/}
      {/*                    <CustomPercentageInput*/}
      {/*                      value={*/}
      {/*                        props.parent.state.formdata.payments?.paymentProviders?.[paymentProvider.name]?.[*/}
      {/*                          paymentMethod.name*/}
      {/*                        ]?.purchase_percentage ?? 0*/}
      {/*                      }*/}
      {/*                      onChange={(e) => {*/}
      {/*                        handlePaymentChange(*/}
      {/*                          paymentProvider.name,*/}
      {/*                          paymentMethod.name,*/}
      {/*                          "purchase_percentage",*/}
      {/*                          e.value*/}
      {/*                        );*/}
      {/*                      }}*/}
      {/*                    />*/}
      {/*                  </TableCell>*/}
      {/*                </TableRow>*/}
      {/*              );*/}
      {/*            });*/}
      {/*          })}*/}
      {/*        </TableBody>*/}
      {/*      </Table>*/}
      {/*    </GridContainer>*/}
      {/*  </CardBody>*/}
      {/*</Card>*/}
    </>
  );
}

export default SubsPricePlanGeneral;
